module.exports = __webpack_public_path__ + "media/lead_gen_offers/ncsa-e4ec81e8.png";